import { render } from "./AddTodo.vue?vue&type=template&id=6ea0e238"
import script from "./AddTodo.vue?vue&type=script&lang=js"
export * from "./AddTodo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__